import React, { useEffect, useState } from 'react';
import axios from 'axios';
import enviarCorreo from "../../firebase/enviarCorreo";
import './FormularioAuto.css';


function FormularioAutoexclusion({ onSuccess }) {
  const [nombre, setNombre] = useState('');
  const [dni, setDni] = useState('');
  const [domicilio, setDomicilio] = useState('');
  const [nacionalidad, setNacionalidad] = useState('');
  const [telefono, setTelefono] = useState('');
  const [mail, setMail] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [dniPdf, setDniPdf] = useState(null);
  const [files, setFiles] = useState([null, null]);
  const [declaracion1, setDeclaracion1] = useState(false);
  const [declaracion11, setDeclaracion11] = useState(false);
  const [declaracion2, setDeclaracion2] = useState(false);
  const [declaracion3, setDeclaracion3] = useState(false);
  const [declaracion4, setDeclaracion4] = useState(false);
  const [declaracion5, setDeclaracion5] = useState(false);
  const [alta, setAlta] = useState(new Date().toISOString().split('T')[0]);
  const [telefonoApoyo, setTelefonoApoyo] = useState('');
  const [ocupacion, setOcupacion] = useState('');
  const [localidad, setLocalidad] = useState('');
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [nombrePersonaApoyo, setNombrePersonaApoyo] = useState('');
  const [observacionInput, setObservacionInput] = useState('');
  const [lugarEntrega, setLugarEntrega] = useState('');
  const [errors, setErrors] = useState({});
  const [previewUrls, setPreviewUrls] = useState([null, null]);
  const [isProcessingFiles, setIsProcessingFiles] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const clearError = (key) => {
    setErrors((prev) => ({ ...prev, [key]: null }));
  };

  const handlePdfChange = (e) => {
    const file = e.target.files[0];
    setPdfFile(file);
    clearError('pdfAlta');
  };

  const handleDniPdfChange = (e) => {
    const file = e.target.files[0];
    setDniPdf(file);
  };

  const getFileType = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        const arr = new Uint8Array(reader.result).subarray(0, 4);
        let header = '';
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        resolve(getMimeType(header));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const getMimeType = (header) => {
    switch (header) {
      case '89504e47':
        return 'image/png';
      case '47494638':
        return 'image/gif';
      case 'ffd8ffe0':
      case 'ffd8ffe1':
      case 'ffd8ffe2':
        return 'image/jpeg';
      case '504b0304':
        return 'application/zip';
      default:
        return 'unknown';
    }
  };

  const enviarCorreos = async (listaCorreos, asunto, texto) => {
    const promesasEnvio = listaCorreos.map(correo =>
      enviarCorreo(correo, asunto, texto)
        .then(() => console.log('Correo enviado correctamente a:', correo))
        .catch(error => {
          console.error('Error al enviar correo a:', correo, error);
        })
    );

    await Promise.all(promesasEnvio);
  };

  const formatFechaHora = (marcaDeTiempo) => {
    const fecha = new Date(marcaDeTiempo);
    const opciones = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "UTC",
    };
    return new Intl.DateTimeFormat("es-AR", opciones).format(fecha);
  };

  const cropToSquareJpeg = (file) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const objectUrl = URL.createObjectURL(file);
      image.onload = () => {
        const size = Math.min(image.width, image.height);
        const sx = Math.floor((image.width - size) / 2);
        const sy = Math.floor((image.height - size) / 2);

        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, sx, sy, size, size, 0, 0, size, size);

        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(objectUrl);
            if (!blob) {
              reject(new Error('No se pudo recortar la imagen.'));
              return;
            }
            const baseName = file.name.replace(/\.[^/.]+$/, '');
            const croppedFile = new File([blob], `${baseName}_square.jpg`, { type: 'image/jpeg' });
            resolve(croppedFile);
          },
          'image/jpeg',
          0.92
        );
      };
      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('No se pudo leer la imagen.'));
      };
      image.src = objectUrl;
    });
  };

  const ensureSquareImage = async (file) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    const dimensions = await new Promise((resolve, reject) => {
      image.onload = () => resolve({ width: image.width, height: image.height });
      image.onerror = () => reject(new Error('No se pudo leer la imagen.'));
      image.src = objectUrl;
    });
    URL.revokeObjectURL(objectUrl);

    if (dimensions.width !== dimensions.height) {
      return await cropToSquareJpeg(file);
    }
    return file;
  };

  const handleFileChange = async (e, index) => {
    setIsProcessingFiles(true);
    const newFiles = [...files];
    newFiles[index] = e.target.files[0];

    if (newFiles[index]) {
      try {
        // Si no es cuadrada, se recorta al centro
        newFiles[index] = await ensureSquareImage(newFiles[index]);

        // Verifica que el tamaño del archivo sea menor a 250 KB
        const fileSize = newFiles[index].size / 1024; // Convertir a KB
        if (fileSize > 250) {
          alert('El tamaño de la imagen debe ser menor a 250 KB. Por favor, selecciona una imagen más pequeña.');
          newFiles[index] = null;
        }
      } catch (error) {
        console.error(error);
        alert('No se pudo procesar la imagen. Inténtalo con otra.');
        newFiles[index] = null;
      }
    }

    setFiles(newFiles);
    if (index === 0) {
      setErrors((prev) => ({ ...prev, foto: null }));
    }
    setIsProcessingFiles(false);
  };

  useEffect(() => {
    const urls = files.map((file) => (file ? URL.createObjectURL(file) : null));
    setPreviewUrls((prev) => {
      prev.forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
      return urls;
    });
    return () => {
      urls.forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [files]);

  const validateForm = () => {
    const nextErrors = {};
    if (!nombre.trim()) nextErrors.nombre = 'Campo obligatorio.';
    if (!dni.trim()) nextErrors.dni = 'Campo obligatorio.';
    if (!telefonoApoyo.trim()) nextErrors.telefonoApoyo = 'Campo obligatorio.';
    if (!mail.trim()) nextErrors.mail = 'Campo obligatorio.';
    if (!lugarEntrega.trim()) nextErrors.lugarEntrega = 'Campo obligatorio.';
    if (!alta) nextErrors.alta = 'Campo obligatorio.';
    if (!files[0]) nextErrors.foto = 'Debe adjuntar una foto.';
    if (!pdfFile) nextErrors.pdfAlta = 'Debe adjuntar el PDF del alta.';
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting || isProcessingFiles) {
      return;
    }
    setIsSubmitting(true);
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    const validSize = 250 * 1024; // 250KB
    const areFilesValid = await Promise.all(
      files.map(async (file) => {
        if (!file) {
          return true;
        }

        const fileType = await getFileType(file);
        if (fileType !== 'image/jpeg' || file.size > validSize) {
          return false;
        }
        return true;
      })
    );

    if (!areFilesValid.every((valid) => valid)) {
      const invalidFiles = files.filter(
        (file, index) =>
          file &&
          (areFilesValid[index] === false ||
            file.type !== 'image/jpeg' ||
            file.size > validSize)
      );
      const invalidFileDetails = invalidFiles.map((file) => ({
        name: file ? file.name : 'Archivo inválido',
        type: file ? getFileExtension(file.name) : 'Desconocido',
      }));

      const errorMessage = `Los siguientes archivos no son válidos:\n${invalidFileDetails
        .map((file) => `${file.name} (${file.type})`)
        .join('\n')}\n\nDeben ser de formato JPG y tener un tamaño menor a 250KB`;
      alert(errorMessage);
      return;
    }

    try {
      if (!pdfFile) {
        alert('Debe adjuntar el PDF del alta.');
        setIsSubmitting(false);
        return;
      }

      const pdfMaxSize = 500 * 1024; // 500KB
      if (pdfFile.size > pdfMaxSize) {
        alert('El archivo PDF debe tener un tamaño menor a 500KB');
        setIsSubmitting(false);
        return;
      }
      if (dniPdf && dniPdf.size > pdfMaxSize) {
        alert('El archivo PDF debe tener un tamaño menor a 500KB');
        setIsSubmitting(false);
        return;
      }

      const formData = new FormData();
      formData.append('nombre', nombre);
      formData.append('dni', dni);
      if (domicilio) formData.append('domicilio', domicilio);
      if (nacionalidad) formData.append('nacionalidad', nacionalidad);
      if (telefono) formData.append('telefono', telefono);
      formData.append('telefonoApoyo', telefonoApoyo);
      formData.append('mail', mail);
      formData.append('lugarEntrega', lugarEntrega);
      if (ocupacion) formData.append('ocupacion', ocupacion);
      if (localidad) formData.append('localidad', localidad);
      if (fechaNacimiento) formData.append('fechaNacimiento', fechaNacimiento);
      if (nombrePersonaApoyo) formData.append('nombrePersonaApoyo', nombrePersonaApoyo);
      formData.append('alta', alta);
      if (observacionInput.trim()) formData.append('observacion', observacionInput.trim());
      formData.append('declaracion1', String(declaracion1));
      formData.append('declaracion11', String(declaracion11));
      formData.append('declaracion2', String(declaracion2));
      formData.append('declaracion3', String(declaracion3));
      formData.append('declaracion4', String(declaracion4));
      formData.append('declaracion5', String(declaracion5));

      files.forEach((file) => {
        if (file) formData.append('fotos', file);
      });
      formData.append('pdfAlta', pdfFile);
      if (dniPdf) formData.append('pdfDni', dniPdf);

      try {
        const response = await axios.post(
          'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/autoexcluidos',
          formData
        );
        if (response?.status === 201 || response?.status === 200) {
          alert('Los datos se han cargado correctamente');
          try {
            const fechaAlta1 = new Date(alta);
            const fechaVencimiento1 = new Date(fechaAlta1.getFullYear() + 2, fechaAlta1.getMonth(), fechaAlta1.getDate());
            const texto = `
    <h3 style="text-align: justify;">A La empresa:<br /><br />SU DESPACHO:<br /><br />Tengo el agrado de dirigirme a Usted, con el objeto de comunicarle que el día ${formatFechaHora(alta).split(',')[0]}, el SRA./SR ${nombre} , DNI ${dni}, ha procedido a firmar voluntariamente el formulario de AUTOEXCLUSI&Oacute;N, en las instalaciones de ${lugarEntrega} por lo que se informa que el mismo tendrá una vigencia de DOS (2) AÑOS, que se renovará de manera automática, en caso de no presentar en&nbsp;Nuestra Institución, Sito en Av. Italia N&ordm;39 &ndash; de esta Ciudad, el Acta de Revocación, acompa&ntilde;ada del debido Certificado médico de alta del tratamiento correspondiente.</h3>
    <h3 style="text-align: justify;"><br />Por todo ello, se comunica a Usted que deber&aacute; impedir el ingreso de SRA./SR ${nombre} a todas las Salas de Juego físicas u online de la Provincia de Jujuy, desde el ${formatFechaHora(fechaAlta1).split(',')[0]} y por el periodo de DOS (2) A&Ntilde;OS hasta el ${formatFechaHora(fechaVencimiento1).split(',')[0]}, todo ello según lo dispuesto por Resolución N&ordm; 047-VP-2022- dispuesta por el Instituto Provincial de Juegos de Azar de Jujuy (InProJuy), el cual dispone el procedimiento de AUTOEXCLUSIONES.</h3>
    <h3>Sin otro particular saludo a Usted, muy atentamente.</h3>
    `;
            const automailsResponse = await fetch('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/automails');
            const data = await automailsResponse.json();
            const listaCorreos = data.map(item => item.email);
            await enviarCorreos(listaCorreos, 'Alta Autoexcluido', texto);
          } catch (mailError) {
            console.error('Error enviando correos de alta', mailError);
          }
          if (typeof onSuccess === 'function') {
            onSuccess();
          }
          return;
        }
      } catch (err) {
        const status = err?.response?.status;
        if (status === 409) {
          alert('Ya existe un autoexcluido con este DNI en la base de datos.');
          setIsSubmitting(false);
          return;
        }
        const message = err?.response?.data?.message || err?.response?.data?.error;
        alert(message || 'Error al cargar los datos. Inténtalo de nuevo.');
      }
    } catch (error) {
      console.error(error);
      alert('Error al cargar los datos. Inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };


  function getFileExtension(fileName) {
    return fileName.split('.').pop().toLowerCase();
  }


  return (
    <form className="autoexcluido-form" onSubmit={handleSubmit}>
      <div className="autoexcluido-form__header">
        <h3>Alta de Autoexcluido</h3>
        <p className="text-muted">Los campos con * son obligatorios.</p>
      </div>

      <div className="autoexcluido-form__section">
        <h4>Datos personales</h4>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Nombre *</label>
            <input
              type="text"
              className={`form-control${errors.nombre ? ' is-invalid' : ''}`}
              name="nombre"
              value={nombre}
              onChange={(e) => {
                setNombre(e.target.value);
                clearError('nombre');
              }}
              required
            />
            {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">DNI *</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className={`form-control${errors.dni ? ' is-invalid' : ''}`}
              name="dni"
              value={dni}
              onChange={(e) => {
                setDni(e.target.value.replace(/\D/g, ''));
                clearError('dni');
              }}
              onWheel={(e) => e.currentTarget.blur()}
              required
            />
            {errors.dni && <div className="invalid-feedback">{errors.dni}</div>}
          </div>
          <div className="col-md-6">
            <label htmlFor="fechaNacimiento" className="form-label">Fecha de nacimiento</label>
            <input
              type="date"
              className="form-control"
              id="fechaNacimiento"
              value={fechaNacimiento}
              onChange={(e) => setFechaNacimiento(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Nacionalidad</label>
            <input
              type="text"
              className="form-control"
              name="nacionalidad"
              value={nacionalidad}
              onChange={(e) => setNacionalidad(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Domicilio</label>
            <input
              type="text"
              className="form-control"
              name="domicilio"
              value={domicilio}
              onChange={(e) => setDomicilio(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Localidad</label>
            <input
              type="text"
              className="form-control"
              name="localidad"
              value={localidad}
              onChange={(e) => setLocalidad(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Ocupación</label>
            <input
              type="text"
              className="form-control"
              name="ocupacion"
              value={ocupacion}
              onChange={(e) => setOcupacion(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="autoexcluido-form__section">
        <h4>Contacto</h4>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">E-mail *</label>
            <input
              required
              type="email"
              className={`form-control${errors.mail ? ' is-invalid' : ''}`}
              name="mail"
              value={mail}
              onChange={(e) => {
                setMail(e.target.value);
                clearError('mail');
              }}
            />
            {errors.mail && <div className="invalid-feedback">{errors.mail}</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">Teléfono</label>
            <input
              type="tel"
              className="form-control"
              name="telefono"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Nombre de persona de apoyo</label>
            <input
              type="text"
              className="form-control"
              name="nombrePersonaApoyo"
              value={nombrePersonaApoyo}
              onChange={(e) => setNombrePersonaApoyo(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Teléfono de apoyo *</label>
            <input
              type="tel"
              className={`form-control${errors.telefonoApoyo ? ' is-invalid' : ''}`}
              name="telefonoApoyo"
              value={telefonoApoyo}
              onChange={(e) => {
                setTelefonoApoyo(e.target.value);
                clearError('telefonoApoyo');
              }}
              required
            />
            {errors.telefonoApoyo && <div className="invalid-feedback">{errors.telefonoApoyo}</div>}
          </div>
        </div>
      </div>

      <div className="autoexcluido-form__section">
        <h4>Alta y entrega</h4>
        <div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="alta" className="form-label">Fecha de alta *</label>
            <input
              type="date"
              className={`form-control${errors.alta ? ' is-invalid' : ''}`}
              id="alta"
              value={alta}
              onChange={(e) => {
                setAlta(e.target.value);
                clearError('alta');
              }}
              required
            />
            {errors.alta && <div className="invalid-feedback">{errors.alta}</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">Lugar de entrega *</label>
            <input
              type="text"
              className={`form-control${errors.lugarEntrega ? ' is-invalid' : ''}`}
              name="lugarEntrega"
              value={lugarEntrega}
              onChange={(e) => {
                setLugarEntrega(e.target.value);
                clearError('lugarEntrega');
              }}
              required
            />
            {errors.lugarEntrega && <div className="invalid-feedback">{errors.lugarEntrega}</div>}
          </div>
          <div className="col-12">
            <label className="form-label">Observación</label>
            <textarea
              className="form-control"
              name="observacion"
              value={observacionInput}
              onChange={(e) => setObservacionInput(e.target.value)}
              maxLength={500}
              rows={3}
              placeholder="Opcional"
            />
          </div>
        </div>
      </div>

      <div className="autoexcluido-form__section">
        <h4>Documentación</h4>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Foto (JPG, cuadrada, hasta 250 KB) *</label>
            <input
              required
              type="file"
              accept="image/jpeg"
              className={`form-control${errors.foto ? ' is-invalid' : ''}`}
              onChange={(e) => handleFileChange(e, 0)}
              disabled={isProcessingFiles || isSubmitting}
            />
            <div className="form-text">Se recorta automáticamente al centro si no es cuadrada.</div>
            {files[0] && <div className="form-text">Archivo: {files[0].name}</div>}
            {errors.foto && <div className="invalid-feedback">{errors.foto}</div>}
            {previewUrls[0] && (
              <div className="autoexcluido-form__preview">
                <img src={previewUrls[0]} alt="Vista previa foto 1" />
              </div>
            )}
            {isProcessingFiles && <div className="form-text">Procesando imagen...</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">PDF del alta (hasta 500 KB) *</label>
            <input
              required
              type="file"
              accept="application/pdf"
              className={`form-control${errors.pdfAlta ? ' is-invalid' : ''}`}
              onChange={handlePdfChange}
              disabled={isSubmitting}
            />
            {pdfFile && <div className="form-text">Archivo: {pdfFile.name}</div>}
            {errors.pdfAlta && <div className="invalid-feedback">{errors.pdfAlta}</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">PDF del DNI (hasta 500 KB)</label>
            <input
              type="file"
              accept="application/pdf"
              className="form-control"
              onChange={handleDniPdfChange}
              disabled={isSubmitting}
            />
            {dniPdf && <div className="form-text">Archivo: {dniPdf.name}</div>}
          </div>
        </div>
      </div>

      <div className="autoexcluido-form__actions">
        <button className="btn btn-primary" type="submit" disabled={isSubmitting || isProcessingFiles}>
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Enviando...
            </>
          ) : (
            'Enviar alta'
          )}
        </button>
      </div>
    </form>
  );
}

export default FormularioAutoexclusion;
